import moment from 'moment';

/**
 * Otp資料
 * @returns {Object}
 */
const state = () => ({
    mobile: null,
    email: null,
    id: null,
    birthday: null,
    login: {
        frontCode: null,
        expired: null, // Date()
        clientExpired: null,
    },
    register: {
        frontCode: null,
        expired: null, // Date()
        clientExpired: null,
    },
});

const actions = {};

const getters = {
    /**
     * 判斷註冊用的 OTP 是否已過期
     * @param {*} state
     * @returns {Boolean}
     */
    registerOtpCodeAvailable: (state) => {
        return (
            state.register.frontCode &&
            state.register.expired
        );
    },
    /**
     * 依據登入帳號(ID)判斷 store 是否已存有未過期的 register OTP 資料
     * @param {*} state
     * @param {*} getters
     * @returns
     */
    registerOtpCodeAvailableWithId: (state, getters) => (id) => {
        return id && id === state.id && getters.registerOtpCodeAvailable;
    },
    /**
     * 判斷登入用的 OTP 是否已過期
     * @param {*} state
     * @returns
     */
    loginOtpCodeAvailable: (state) => {
        return (
            state.login.frontCode &&
            state.login.expired
        );
    },
};

const mutations = {
    /**
     * 清空資料
     * @param {*} state
     */
    clear(state) {
        state.email = null;
        state.mobile = null;
        state.id = null;
        state.birthday = null;
        state.login.frontCode = null;
        state.login.expired = null;
        state.login.clientExpired = null;
        state.register.frontCode = null;
        state.register.expired = null;
        state.register.clientExpired = null;
    },
    /**
     * 清除登入 OTP 資料
     * @param {*} state
     */
    clearLogin(state) {
        state.login.frontCode = null;
        state.login.expired = null;
        state.login.clientExpired = null;
    },
    /**
     * 清除註冊 OTP 資料
     * @param {*} state
     */
    clearRegister(state) {
        state.register.frontCode = null;
        state.register.expired = null;
        state.register.clientExpired = null;
    },
    /**
     * 設定會員登入資料
     * @param {*} state
     * @param {*} payload
     */
    setLogin(state, payload) {
        state.mobile = payload.mobile;
        state.email = payload.email;
        state.id = payload.id;
        state.birthday = payload.birthday;
        state.login.frontCode = payload.frontCode;
        state.login.expired = payload.expired;
        state.login.clientExpired = moment().add(300, 'seconds').format('YYYY-MM-DDTHH:mm:ss.SSS');
    },
    /**
     * 設定註冊資料
     * @param {*} state
     * @param {*} payload
     */
    setRegister(state, payload) {
        state.mobile = payload.mobile;
        state.email = payload.email;
        state.id = payload.id;
        state.birthday = payload.birthday;
        state.register.frontCode = payload.frontCode;
        state.register.expired = payload.expired;
        state.register.clientExpired = moment().add(300, 'seconds').format('YYYY-MM-DDTHH:mm:ss.SSS');
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
